import React from "react";
import { Form } from "react-bootstrap";

export const StepFiveReview = ({ patientDetails, isBookingDetail = true, selectedTestsData, specimenCollectedDate }) => {
  const { name, email, dob, address, genderAtBirth } = patientDetails;
  console.log("selectedTestsData", selectedTestsData);
  return (
    <div className="step-form">
      <h3>Review</h3>
      <Form>
        <div className="step-form">
          <div className="form-group">
            <label htmlFor="patientInfo">Patient</label>
            <div id="patientInfo" className={`patient-info ${isBookingDetail ? "grayed-out" : ""}`}>
              <div className="patient-name">{name}</div>
              <div className="patient-details">{`${email} , ${dob} , ${genderAtBirth} , ${address?.region}`}</div>
            </div>
          </div>
        </div>
        <Form>
          <Form.Group controlId="formBasicVendor">
            <Form.Label>Vendor</Form.Label>
            <div>
              <Form.Check type="radio" checked label="LIFESCAN" name="LIFESCAN" id="LIFESCAN" className="form-check-ques" />
            </div>
          </Form.Group>
        </Form>
      </Form>
      <h3
        style={{
          marginTop: "20px"
        }}
      >
        Orders
      </h3>
      {selectedTestsData.map(
        (mainTest, index) =>
          mainTest?.panel && (
            <div key={index} style={{ marginTop: "10px" }}>
              <h4>{mainTest.testOrPanelName}</h4>
              <Form.Group>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px"
                  }}
                >
                  {mainTest.specifications.map(subtest => (
                    <Form.Check
                      className="form-check-ques"
                      key={subtest.testCode}
                      type="checkbox"
                      label={subtest.testName}
                      disabled={!subtest.editable}
                      checked={true}
                    />
                  ))}
                </div>
              </Form.Group>
              <div
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  borderBottom: "1px solid #e0e0e0"
                }}
              />
            </div>
          )
      )}
      {selectedTestsData.filter(test => !test.panel).length > 0 && (
        <div>
          <h4>Individual</h4>
          <Form.Group>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px"
              }}
            >
              {selectedTestsData
                .filter(test => !test.panel)
                .map(subtest => (
                  <Form.Check
                    className="form-check-ques"
                    key={subtest.testCode}
                    type="checkbox"
                    label={subtest.testOrPanelName}
                    disabled={!subtest.editable}
                    checked={true}
                  />
                ))}
            </div>
          </Form.Group>
        </div>
      )}

      <div
        style={{
          marginTop: "20px",
          flexDirection: "column",
          gap: "5px"
        }}
      >
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          }}
        >
          <Form.Group controlId="formBasicSpecimenCollected">
            <Form.Label>Specimen Collected Date</Form.Label>
            <Form.Control type="date" value={specimenCollectedDate} disabled />
          </Form.Group>
        </div>
      </div>
    </div>
  );
};
